import { Sparkles, PencilLine } from "lucide-react";
import type { ExtractedFieldMetadata } from "@/types/extraction";

interface PreFilledBadgeProps {
  metadata: ExtractedFieldMetadata;
}

/**
 * Small pill shown next to the label for a field that was pre-filled from
 * the user's uploaded declarations page. Tracks whether the user has since
 * edited the value.
 */
export function PreFilledBadge({ metadata }: PreFilledBadgeProps) {
  if (metadata.source === "user_entered") return null;

  const isEdited = metadata.source === "user_edited";
  const label = isEdited ? "Edited" : "From your policy";
  const Icon = isEdited ? PencilLine : Sparkles;

  return (
    <span
      className="inline-flex items-center gap-1 ml-2"
      style={{
        background: isEdited ? "var(--bg-muted, #F3F4F6)" : "#ECFDF5",
        color: isEdited ? "var(--text-secondary)" : "#166534",
        fontSize: 11,
        fontWeight: 600,
        padding: "2px 8px",
        borderRadius: 999,
        verticalAlign: "middle",
      }}
      title={
        metadata.sourceQuote
          ? `From your policy: "${metadata.sourceQuote}"`
          : label
      }
    >
      <Icon size={11} strokeWidth={2.5} />
      {label}
    </span>
  );
}
